import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { AdministrationUserDashboardService } from 'src/app/core/services/administration/user-dashboard.service';
import { Api } from 'src/app/api/gse/api';
import { getPendingDelegatedTasks } from 'src/app/api/gse/functions';
import * as AdminUserDashboardActions from './user-dashboard.actions';

@Injectable()
export class AdminUserDashboardEffects {
  private readonly actions$ = inject(Actions);
  private readonly service = inject(AdministrationUserDashboardService);
  private readonly api = inject(Api);

  loadSummary$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminUserDashboardActions.loadUserDashboardSummary),
      switchMap(() =>
        this.service.getUserSummary().pipe(
          map((res) =>
            AdminUserDashboardActions.loadUserDashboardSummarySuccess({
              data: res?.data?.[0] ?? null,
            })
          ),
          catchError((error) =>
            of(AdminUserDashboardActions.loadUserDashboardSummaryFailure({ error }))
          )
        )
      )
    )
  );

  loadDelegationOverview$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminUserDashboardActions.loadDelegationOverview),
      switchMap(({ range }) =>
        this.service.getDelegationOverview(range).pipe(
          map((res) =>
            AdminUserDashboardActions.loadDelegationOverviewSuccess({
              data: res?.data ?? [],
            })
          ),
          catchError((error) =>
            of(AdminUserDashboardActions.loadDelegationOverviewFailure({ error }))
          )
        )
      )
    )
  );

  loadTechnicianLeaderboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminUserDashboardActions.loadTechnicianLeaderboard),
      switchMap(({ params }) =>
        this.service.getTechnicianLeaderboard(params).pipe(
          map((res) =>
            AdminUserDashboardActions.loadTechnicianLeaderboardSuccess({
              data: res?.data ?? [],
            })
          ),
          catchError((error) =>
            of(AdminUserDashboardActions.loadTechnicianLeaderboardFailure({ error }))
          )
        )
      )
    )
  );

  loadPendingDelegatedTasks$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminUserDashboardActions.loadPendingDelegatedTasks),
      switchMap(({ limit, from, to }) => {
        return this.api.invoke(getPendingDelegatedTasks, { limit, from, to, status: 'NEW' }).pipe(
          map((res) =>
            AdminUserDashboardActions.loadPendingDelegatedTasksSuccess({
              data: res?.data ?? [],
            })
          ),
          catchError((error) =>
            of(AdminUserDashboardActions.loadPendingDelegatedTasksFailure({ error }))
          )
        );
      })
    )
  );
}

